import { draftColors } from "./draftDesignTokens";

export const drawerTabStyles = {
  backgroundColor: "#F2F5F9",
  borderRadius: "8px",
  padding: "2px",
  minHeight: "36px",
  "& .MuiTab-root": {
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "none",
    color: draftColors.textSecondary,
    minHeight: "32px",
    py: "4px",
    borderRadius: "6px",
    zIndex: 1,
  },
  "& .Mui-selected": {
    color: `${draftColors.textPrimary} !important`,
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
  },
  "& .MuiTabs-indicator": { display: "none" },
} as const;
